var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0834 31.6593C29.332 30.2549 34 24.6726 34 18C34 10.268 27.732 4 20 4C12.268 4 6 10.268 6 18C6 24.6726 10.668 30.2549 16.9166 31.6593L20 37L23.0834 31.6593Z",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.41V20.59C18 20.985 18.435 21.225 18.77 21.01L22.84 18.42C23.15 18.225 23.15 17.775 22.84 17.575L18.77 14.99C18.435 14.775 18 15.015 18 15.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.70cd7604e22b65f7625aaf1fce28e0f1.svg";
export { ForwardRef as ReactComponent };